import { render, staticRenderFns } from "./PageTags.vue?vue&type=template&id=31d8f051&scoped=true"
import script from "./PageTags.vue?vue&type=script&lang=js"
export * from "./PageTags.vue?vue&type=script&lang=js"
import style0 from "./PageTags.vue?vue&type=style&index=0&id=31d8f051&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d8f051",
  null
  
)

export default component.exports